import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MSC_SEVERITY_LEVEL_CONTACTS } from './data/msc-severity-level-contacts';
import { NOC_SEVERITY_LEVEL_CONTACTS } from './data/noc-severity-level-contacts';

@Component({
  selector: 'app-noc-policy',
  templateUrl: './noc-policy.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NocPolicyComponent {
  readonly nocSeverityLevelContacts = NOC_SEVERITY_LEVEL_CONTACTS;

  readonly mscSeverityLevelContacts = MSC_SEVERITY_LEVEL_CONTACTS;
}
